<template>
  <div>
    <card-loading-transparent v-if="loading"></card-loading-transparent>
    <div v-if="!loading && event.id">
      <v-row class="d-flex justify-center">
        <v-col cols="12" md="12" class="ml-4 mb-n4">
          <div class="my-n2">
            <span style="font-weight: bold; color: black">Status: </span><v-icon small :color="event_status_map[event.status].color" class="mt-n1">mdi-circle</v-icon> <span style=" color: black">{{event_status_map[event.status].text}}</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center" v-if="!is_event">
        <v-col cols="12" md="12" class="px-5">
          <div>
            <span style="font-weight: bold; color: black">Bloqueio de agenda </span> 
            <span style=" color: black">{{event.name}}</span>
          </div>
          <div v-if="event.category == 'event' ">
            <span style="font-weight: bold; color: black">Data de início: </span> <span style=" color: black">{{event_start_at}}</span>
          </div>
          <div v-if="event.category == 'block_calendar'">
            <span style="font-weight: bold; color: black">Data: </span> {{ formatDateToShow }}
          </div>
          <!-- <div>
            <span style="font-weight: bold; color: black">Data de término: </span><span style=" color: black">{{event_end_at}}</span>
          </div> -->
        </v-col>
      </v-row>
      <template v-if="is_event">
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="12" class="px-5">
            <div>
              <span style="font-weight: bold; color: black">Evento: </span> 
              <span style=" color: black">{{event.name}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Data do Evento: </span> <span style=" color: black">{{event_start_at}}</span>
            </div>
            <!-- <div>
              <span style="font-weight: bold; color: black">Data de término: </span><span style=" color: black">{{event_end_at}}</span>
            </div> -->
            <div v-if="event_details">
              <span style="font-weight: bold; color: black">Endereço: </span><span style=" color: black">{{event_details.address}}</span>
              <span style="font-weight: bold; color: black"> Local: </span> <span style=" color: black">{{event_details.place || ''}}</span>
            </div>
            <div class="d-flex justify-space-between">
              <!-- <div>CIDADE: <span style=" color: black">{{event_city}}</span></div> -->
              <!-- <div>UF: <span style=" color: black">{{event_state}}</span></div> -->
              <div><span style="font-weight: bold; color: black">País: </span> <span style=" color: black">{{ event_country }}</span></div>
            </div>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="12" class="px-5">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="6" class="px-5" v-if="event_contact">
            <div>
              <span style="font-weight: bold; color: black">Responsável: </span><span style=" color: black">{{responsible_name}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Conexão: </span> <span style=" color: black">{{responsible_kind}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Telefone: </span> <span style=" color: black">{{responsible_phone}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Email: </span> <span style="  color: black">{{responsible_email}}</span>
            </div>
          </v-col>
          <v-divider
            vertical
          ></v-divider>
          <v-col cols="12" md="6" class="px-5">
            <div v-if="event_details">
              <span style="font-weight: bold; color: black">Dimensão: </span><span style=" color: black">{{event_size_map[event_details.size]}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Categoria: </span><span style=" color: black">{{event_category}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Perfil do evento: </span><span style=" color: black">{{event_kind}}</span>
            </div>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="12" class="px-5">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-start">
          <v-col cols="12" md="6" class="px-5">
            <div>
              <span style="font-weight: bold; color: black">Precisa de logística: </span> <span style="  color: black">{{true_or_false_map[needs_logistics]}}</span>
            </div>
            <div>
              <span v-if="needs_logistics" style="font-weight: bold; color: black">Responsável pela Logística: </span> <span style="  color: black">{{logistics_by}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Precisa de Acomodação: </span> <span style="  color: black">{{true_or_false_map[needs_accommodation]}}</span>
            </div>
            <div>
              <span v-if="needs_accommodation" style="font-weight: bold; color: black">Responsável pela Acomodação: </span> <span style="  color: black">{{accommodation_by}}</span>
            </div>
          </v-col>
          <v-divider
            vertical
          ></v-divider>
          <v-col cols="12" md="6" class="px-5">
            <div>
              <span style="font-weight: bold; color: black">Tempo total de trabalho: </span><span style=" color: black">{{work_time}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Número de shows: </span> <span style=" color: black">{{number_of_shows}}</span>
            </div>
            <div>
              <span style="font-weight: bold; color: black">Método de pagamento: </span> <span style=" color: black">{{payment_method}}</span>
            </div>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Api from '@/api'

  export default {
    name: 'ShowEventInfos',
    props: {
      event: {
        type: Object,
        default: ()=> {}
      },
      event_details: {
        type: Object,
        default: ()=> {}
      },
      event_contact: {
        type: Object,
        default: ()=> {}
      },
    },
    components: {
    },
    data() {
      return {
        true_or_false_map: {
          true: 'Sim',
          false: 'Não'
        },
        event_size_map:{
          small: 'Pequeno',
          medium: 'Médio',
          big: 'Grande',
          extra_big: 'Extra Grande',
        },
        contact_kind_map: {
          producer: 'Produtor',
          owner: 'Proprietário',
          collaborator: 'Colaborador',
        },
        event_kind_map: {
          social: 'Social',
          corporative: 'Corporativo',
          cultural: 'Cultural',
          eletronic: 'Eletrônico',
          festival: 'Festival',
          congress: 'Congresso/Feira',
          restaurant: 'Bar/Restaurante',
          other: 'Outro'
        },
        event_status_map:{
          waiting: { text: 'Aguardando', color: 'amber' },
          open: { text: 'Confirmado', color: 'primary' },
          cancelled: { text: 'Cancelado', color: 'error' },
          executed: { text: 'Executado', color: 'success' },
          in_negociation: { text: 'Negociando', color: 'primary' },
          canceled_negociation: { text: 'Cancelada', color: 'error' },
          filed: { text: 'Arquivada', color: 'secondary' },
        },
        loading: false
      }
    },
    mounted() {
    },
    methods: {
    },
    computed: {
      payment_method(){
        if(this.event.json_attributes.additional_details != undefined){
          return this.event.json_attributes.additional_details.payment_method || ''
        }
        return ''
      },
      work_time(){
        if(this.event.json_attributes.additional_details != undefined && this.event.json_attributes.additional_details.work_time != null){
          return this.event.json_attributes.additional_details.work_time+' min'
        }else{
          return ''
        }
      },
      number_of_shows(){
        if(this.event.json_attributes.additional_details != undefined){
          return this.event.json_attributes.additional_details.number_of_shows || ''
        }
        return ''
      },
      needs_logistics(){
        if(this.event.json_attributes.additional_details != undefined){
          return this.event.json_attributes.additional_details.needs_logistics
        }
        return ''
      },
      logistics_by(){
        if(this.event.json_attributes.additional_details != undefined){
          return this.event.json_attributes.additional_details.logistics_by || ''
        }
        return ''
      },
      needs_accommodation(){
        if(this.event.json_attributes.additional_details != undefined){
          return this.event.json_attributes.additional_details.needs_accommodation
        }
        return ''
      },
      accommodation_by(){
        if(this.event.json_attributes.additional_details != undefined){
          return this.event.json_attributes.additional_details.accommodation_by || ''
        }
        return ''
      },
      responsible_name () {
        return this.event_contact.responsible_name ? this.event_contact.responsible_name : ' '
      },
      responsible_email () {
        return this.event_contact.responsible_email ? this.event_contact.responsible_email : ' '
      },
      responsible_kind () {
        return this.event_contact.responsible_kind ? this.contact_kind_map[this.event_contact.responsible_kind] : ' '
      },
      responsible_phone () {
        return this.event_contact.responsible_phone ? this.event_contact.responsible_phone : ' '
      },
      event_city(){
        let adress = this.event_details.address.split(',')
        return adress[3]
      },
      event_state(){
        let adress = this.event_details.address.split(',')
        return adress[4]
      },
      event_category(){
        return this.event.category == 'event' ? 'Evento' : 'Bloqueio de Agenda'
      },
      event_kind(){
        return this.event.kind ? this.event_kind_map[this.event.kind] : ''
      },
      event_country(){
        if(this.event_details){
          // console.log(this.event_details)
          return this.event_details.country ? this.event_details.country : ''
        }
      },
      is_event(){
        return this.event.category == 'event'
      },
      // event_status(){
      //   return this.event.status == 'open' ? 'ABERTO' :
      //   this.event == 'cancelled' ? 'CANCELADO' : 'CONFIRMADO'
      // },
      // event_status_color(){
      //   return this.event.status == 'open' ? 'yellow darken-3' :
      //   this.event == 'cancelled' ? 'error' : 'success'
      // },
      event_start_at(){
        return this.$dayjs(this.event.start_at).format('DD/MM/YYYY') // .add(12,'h')
      },
      event_end_at(){
        return this.event.end_at ? this.$dayjs(this.event.end_at).format('DD/MM/YYYY') : ' ' // .add(12,'h')
      },
      formatDateToShow(){
        let s_date = this.$dayjs(this.event.start_at).format('DD/MM/YYYY [as] HH:mm')
        let e_date = this.$dayjs(this.event.start_at).isSame(this.event.end_at, 'day') ? 
        this.$dayjs(this.event.end_at).format('HH:mm') :
        this.$dayjs(this.event.end_at).format('DD/MM/YYYY [as] HH:mm')
        
        return s_date + ' até ' + e_date
      },
      ...mapState({
        event_info: state => state.Event.event_info,
        activeCompany: state => state.App.activeCompany
      }),
    },

  }
</script>

<style lang="scss" scoped>

</style>